"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var core_1 = require("@bodiless/core");

var useTagsAccessors = function useTagsAccessors() {
  var node = core_1.useNode().node;
  return {
    getTags: function getTags() {
      return node.data.tags || [];
    },
    tag: lodash_1.isEmpty(node.data.tags) ? {
      id: '',
      name: ''
    } : node.data.tags[0],
    nodeId: node.path[node.path.length - 2] === 'default' ? node.path.toString() : node.path[node.path.length - 2]
  };
};

exports.default = useTagsAccessors;